import './NavBarContainer.css'
import { NavBar } from '../../components/NavBar/NavBar'

export const NavBarContainer = ( { routes, isIntersecting} ) => {
    
    return (
            <NavBar routes={routes} isIntersecting={isIntersecting}/>
    )
}